import React from "react";
import { FiSearch } from "react-icons/fi";
import styled from "styled-components/macro";
import Box from "./Box";

const Input = styled(Box)`
  display: block;
  box-sizing: border-box;
  width: 100%;
  font-family: inherit;
  ::placeholder {
    color: ${({ theme }) => theme.colors.muted};
  }
`;
Input.defaultProps = { as: "input" };

const variants = {
  large: {
    fontSize: 2,
    lineHeight: 2,
    boxShadow: "md",
    border: "soft",
    p: 3,
    pl: 5,
    icon: {
      py: 2,
      pl: 3,
      color: "muted",
      m: 1,
      fontSize: 4
    }
  }
};

function SearchField({ variant, value, placeholder, onChange, ...rest }) {
  const { icon, ...styles } = variants[variant] || {};
  return (
    <Box position="relative">
      <Box position="absolute" {...icon}>
        <FiSearch />
      </Box>
      <Input
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        {...styles}
        {...rest}
      />
    </Box>
  );
}

export default SearchField;
